import React from "react";
import Sliders from "../Home/Slider";
import FooterMain from "../Layout/FooterMain";
import HeaderMain from "../Layout/HeaderMain";
import HomeNews from "./HomeNews";
import HomeSlider from "./HomeSlider";
import Product1 from "./Product1";
import Confetti from "../Account/Confetti";
import Confetti2 from "../Account/Confetti2";
import Home2 from "./Home2";

function HomeNewComTesting({ cat, sliderdate }) {
  function isWebView() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    console.log(userAgent);

    // Example for Android WebView (check for "wv")
    if (/wv/.test(userAgent) || /Android.*WebView/.test(userAgent)) {
      return true;
    }

    // Example for iOS WebView (check for "iPhone OS" without "Safari")
    if (/iPhone|iPod|iPad/.test(userAgent) && !/Safari/.test(userAgent)) {
      return true;
    }

    return false; // Assume it's a browser if no WebView signature is detected
  }

  if (isWebView()) {
    console.log("Running inside a WebView");
  } else {
    console.log("Running inside a browser");
  }
  return (
    <div>
      {!isWebView() ? (
        <div className="homeColor">
          <HeaderMain />

          <Home2 />

          <FooterMain />
        </div>
      ) : (
        <div>
          <HeaderMain />
          {/* <Confetti2 /> */}
          <Sliders sliderdate={sliderdate} />
          {/* <HomeSlider /> */}

          {/* <Product1 /> */}
          <HomeNews />
          <FooterMain />
        </div>
      )}
    </div>
  );
}

export default HomeNewComTesting;
